import { combineReducers } from '@reduxjs/toolkit';
import {
  campaignItems,
  campaignItemsHasErrored,
  campaignItemsIsLoading,
  campaignItem,
  campaignItemHasErrored,
  campaignItemIsLoading,
  isNewCampaignSaveSuccess,
  isNewCampaignSaveErrored,
  isNewCampaignIsSaving,
  redirectToCampaignListPage,
} from './campaignReducers';
import {
  supplierItems,
  supplierItemsHasErrored,
  supplierItemsIsLoading,
  supplierItem,
  supplierItemHasErrored,
  supplierItemIsLoading,
  purchaseRebateSupplierItems,
  purchaseRebateSupplierItemsHasErrored,
  purchaseRebateSupplierItemsIsLoading,
  purchaseRebateSupplierItem,
  purchaseRebateSupplierItemHasErrored,
  purchaseRebateSupplierItemIsLoading,
  isNewPurchaseRebateSupplierSaveSuccess,
  isNewPurchaseRebateSupplierSaveErrored,
  isNewPurchaseRebateSupplierIsSaving,
  isNewPurchaseRebateSupplierRemoveSuccess,
  isNewPurchaseRebateSupplierRemoveErrored,
  isNewPurchaseRebateSupplierIsRemoving,
} from './supplierReducers';

import {
  promotionList,
  promotionListHasErrored,
  promotionListIsLoading,
  promotionDetails,
  promotionDetailsHasErrored,
  promotionDetailsIsLoading,
  isNewPromotionSaveSuccess,
  isNewPromotionSaveErrored,
  isNewPromotionIsSaving,
  redirectToPromotionListPage,
} from './promotionReducers';
import {
  offerList,
  offerListHasErrored,
  offerListIsLoading,
  offerDetails,
  offerRule,
  offerDetailsHasErrored,
  offerDetailsIsLoading,
  isNewOfferSaveSuccess,
  isNewOfferSaveErrored,
  isNewOfferIsSaving,
  redirectToOfferListPage,
  activateOfferDataSuccess,
  activateOfferSaving,
  activateOfferErrored,
} from './offerReducers';

import {
  fileUploadSuccess,
  fileUploadErrored,
  fileIsUploading,
  cafOfferList,
  cafOfferListHasErrored,
  cafOfferListIsLoading,
  cafHistoryListHasErrored,
  cafHistoryListIsLoading,
  cafHistoryList,
  purchaseRebateCafListHasErrored,
  purchaseRebateCafListIsLoading,
  purchaseRebateCafHistoryList,
} from './importCafFileReducers';

import {
  siteRegionListHasErrored,
  siteRegionListIsLoading,
  siteRegionList,
  regionListHasErrored,
  regionListIsLoading,
  regionList,
  dealFunderListHasErrored,
  dealFunderListIsLoading,
  dealFunderList,
  updateSiteRegionHasErrored,
  siteRegionUpdating,
  siteRegionUpdateSuccess,
  addSiteRegionHasErrored,
  siteRegionAdding,
  siteRegionAddSuccess,
} from './regionReducers';

import {
  purchaseRebateItemsHasErrored,
  purchaseRebateItemsIsLoading,
  purchaseRebateItems,
  purchaseRebateItemHasErrored,
  purchaseRebateItemIsLoading,
  purchaseRebateItem,
  purchaseRebateProductItemsHasErrored,
  purchaseRebateProductItemsIsLoading,
  purchaseRebateProductItems,
} from './purchaseRebateReducers';

import {
  ruleProductListHasErrored,
  ruleProductListIsLoading,
  ruleProductListFetchDataSuccess,
  newRuleProductSaveErrored,
  nnewRuleProductIsSaving,
  newRuleProductSaveSuccess,
  deleteRuleProductHasErrored,
  deleteRuleProductIsLoading,
  deleteRuleProductSuccess,
} from './offerRuleReducers';

import {
  batchProcessListHasErrored,
  batchProcessListIsRunning,
  batchProcessListSuccess,
  runBatchProcessHasErrored,
  runBatchProcessIsRunning,
  runBatchProcessSuccess,
  rollbackBatchProcessHasErrored,
  rollbackBatchProcessIsRunning,
  rollbackBatchProcessSuccess,
} from './batchProcessReducers';

import { dealFunder } from './dealFunderReducers';

import { lossPreventionSettings } from './lossPreventionReducers';

import {
  conversionRateListHasErrored,
  conversionRateListIsLoading,
  conversionRateListData,
  conversionRateAddHasErrored,
  conversionRateAddIsLoading,
  conversionRateAddDataSuccess,
  eftCategoriesListHasErrored,
  eftCategoriesListIsLoading,
  eftCategoriesListData,
  conversionRateDeleteHasErrored,
  conversionRateDeleteIsLoading,
  conversionRateDeleteDataSuccess,
  conversionRateSetEndDateHasErrored,
  conversionRateSetEndDateIsLoading,
  conversionRateSetEndDateDataSuccess,
} from './converstionRateReducers';

export default combineReducers({
  campaignItems,
  campaignItemsHasErrored,
  campaignItemsIsLoading,
  campaignItem,
  campaignItemHasErrored,
  campaignItemIsLoading,
  isNewCampaignSaveSuccess,
  isNewCampaignSaveErrored,
  isNewCampaignIsSaving,
  redirectToCampaignListPage,
  promotionList,
  promotionListHasErrored,
  promotionListIsLoading,
  promotionDetails,
  promotionDetailsHasErrored,
  promotionDetailsIsLoading,
  isNewPromotionSaveSuccess,
  isNewPromotionSaveErrored,
  isNewPromotionIsSaving,
  redirectToPromotionListPage,
  offerList,
  offerListHasErrored,
  offerListIsLoading,
  cafOfferList,
  cafOfferListHasErrored,
  cafOfferListIsLoading,
  cafHistoryListHasErrored,
  cafHistoryListIsLoading,
  cafHistoryList,
  offerDetails,
  isNewOfferSaveSuccess,
  isNewOfferSaveErrored,
  isNewOfferIsSaving,
  redirectToOfferListPage,
  offerRule,
  offerDetailsHasErrored,
  offerDetailsIsLoading,
  fileUploadSuccess,
  fileUploadErrored,
  fileIsUploading,
  supplierItems,
  supplierItemsHasErrored,
  supplierItemsIsLoading,
  supplierItem,
  supplierItemHasErrored,
  supplierItemIsLoading,
  purchaseRebateSupplierItems,
  purchaseRebateSupplierItemsHasErrored,
  purchaseRebateSupplierItemsIsLoading,
  purchaseRebateSupplierItem,
  purchaseRebateSupplierItemHasErrored,
  purchaseRebateSupplierItemIsLoading,
  isNewPurchaseRebateSupplierSaveSuccess,
  isNewPurchaseRebateSupplierSaveErrored,
  isNewPurchaseRebateSupplierIsSaving,
  isNewPurchaseRebateSupplierRemoveSuccess,
  isNewPurchaseRebateSupplierRemoveErrored,
  isNewPurchaseRebateSupplierIsRemoving,
  siteRegionListHasErrored,
  siteRegionListIsLoading,
  siteRegionList,
  regionListHasErrored,
  regionListIsLoading,
  regionList,
  dealFunderListHasErrored,
  dealFunderListIsLoading,
  dealFunderList,
  updateSiteRegionHasErrored,
  siteRegionUpdating,
  siteRegionUpdateSuccess,
  addSiteRegionHasErrored,
  siteRegionAdding,
  siteRegionAddSuccess,
  ruleProductListHasErrored,
  ruleProductListIsLoading,
  ruleProductListFetchDataSuccess,
  newRuleProductSaveErrored,
  nnewRuleProductIsSaving,
  newRuleProductSaveSuccess,
  deleteRuleProductHasErrored,
  deleteRuleProductIsLoading,
  deleteRuleProductSuccess,
  activateOfferDataSuccess,
  activateOfferSaving,
  activateOfferErrored,
  batchProcessListHasErrored,
  batchProcessListIsRunning,
  batchProcessListSuccess,
  runBatchProcessHasErrored,
  runBatchProcessIsRunning,
  runBatchProcessSuccess,
  rollbackBatchProcessHasErrored,
  rollbackBatchProcessIsRunning,
  rollbackBatchProcessSuccess,
  conversionRateListHasErrored,
  conversionRateListIsLoading,
  conversionRateListData,
  conversionRateAddHasErrored,
  conversionRateAddIsLoading,
  conversionRateAddDataSuccess,
  eftCategoriesListHasErrored,
  eftCategoriesListIsLoading,
  eftCategoriesListData,
  conversionRateDeleteHasErrored,
  conversionRateDeleteIsLoading,
  conversionRateDeleteDataSuccess,
  conversionRateSetEndDateHasErrored,
  conversionRateSetEndDateIsLoading,
  conversionRateSetEndDateDataSuccess,
  dealFunder,
  purchaseRebateItemsHasErrored,
  lossPreventionSettings,
  purchaseRebateItemsIsLoading,
  purchaseRebateItems,
  purchaseRebateItemHasErrored,
  purchaseRebateItemIsLoading,
  purchaseRebateItem,
  purchaseRebateProductItemsHasErrored,
  purchaseRebateProductItemsIsLoading,
  purchaseRebateProductItems,
  purchaseRebateCafListHasErrored,
  purchaseRebateCafListIsLoading,
  purchaseRebateCafHistoryList,
});
